module.exports = __webpack_public_path__ + "static/media/template.inactive.6bd1d5a7.svg";